import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { PublicPrimaryCta } from "@/features/public/components/PublicPrimaryCta";
import { usePublicSession } from "@/features/public/hooks/PublicSessionContext";
import { PublicPageShell } from "@/features/public/layout/PublicPageShell";

const FEATURES = [
  {
    icon: "📦",
    title: "High-volume ZIP exports",
    body: "Set search filters — matching invoices are auto-packed into ZIP files. Built for massive batch downloads, up to hundreds of thousands of PDFs in one job.",
  },
  {
    icon: "⚡",
    title: "Live from Stripe",
    body: "No sync step. Search and export read your Stripe data when you need it.",
  },
  {
    icon: "🔐",
    title: "No sign-up needed",
    body: "Open InvoiceVault from the Dashboard drawer — you're redirected to the web app, signed in automatically.",
  },
] as const;

export function PublicHomePage() {
  const session = usePublicSession();

  return (
    <PublicPageShell
      eyebrow="Stripe App · PDF export"
      title="Bulk export Stripe invoice PDFs"
      lead="Bulk exports, receipts, credit notes, and pay links."
      leadMuted={
        <>
          Open from your Stripe Dashboard.
          <span className="pub-home-free-mark">99% of features are free</span>
          No sign-up, auto sign-in from the drawer.
        </>
      }
      actions={
        <>
          <PublicPrimaryCta />
          <Link to={ROUTES.pricing} className="pub-btn pub-btn-secondary">
            View pricing
          </Link>
          <Link to={ROUTES.docs} className="pub-btn pub-btn-ghost">
            Documentation
          </Link>
        </>
      }
    >
      <div className="pub-feature-grid">
        {FEATURES.map((feature) => (
          <div key={feature.title} className="pub-feature-card">
            <div className="pub-feature-icon" aria-hidden>
              {feature.icon}
            </div>
            <h3>{feature.title}</h3>
            <p>{feature.body}</p>
          </div>
        ))}
      </div>
      <div className="pub-install-strip">
        <div>
          <strong className="text-base">
            {session === "authenticated" ? "Continue in InvoiceVault" : "Ready in three steps"}
          </strong>
          <p className="mt-1 text-[0.8125rem] text-[var(--text-secondary)]">
            {session === "authenticated"
              ? "Search, export, and download from your Dashboard."
              : "Install → Open drawer → Export in InvoiceVault."}
          </p>
        </div>
        <PublicPrimaryCta />
      </div>
    </PublicPageShell>
  );
}
